module.exports = __webpack_public_path__ + "images/fafaa7d482dfad61c7c6d3ea5a7790de.svg";